import styled from 'styled-components'

const SortableRow = styled.tr`
    cursor: grab;

    &:active {
        cursor: grabbing;
    }

    &.sortable-chosen {
        background-color: #ffffff;
        opacity: 0.7;
    }

    &.sortable-ghost {
        background-color: ${props => props.theme.admin.colors.background};
        color: ${props => props.theme.admin.colors.background};
        .btn {
            opacity: 0;
        }
    }

    td {
        vertical-align: middle;
    }
`

export default SortableRow
